import React, {useContext, useEffect, useState} from "react";
import {DEVELOPER_API_PATH, PAYMENT_PLAN_API_PATH, AMENITY_API_PATH, PROPERTY_API_PATH} from "../../../../global_vars";
import {AuthContext} from "../../../shared/services/auth-context/auth-context";
import { Developer, DeveloperGetSearchResponse, DeveloperInfo } from "../../../shared/types/developer";
import {PaymentPlan, PaymentPlanSearchResponse, PaymentPlanInfo} from "../../../shared/types/payment-plan";
import {Amenity, AmenityGetResponse, AmenityInfo} from "../../../shared/types/amenity";
import {
    FileJob,
    ImageUploadResponse,
    Property,
    PropertyCreateResponse,
    PropertyInfo,
    PropertyStatus
} from "../../../shared/types/property";
import Select from "react-select";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import './add-property.scss';
import axios from "axios";
import {Button, Modal, ProgressBar} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faMagnifyingGlass, faTimes, faUpload} from "@fortawesome/free-solid-svg-icons";
import {IconProp} from "@fortawesome/fontawesome-svg-core";
import {Filters, PaymentPlanFilters} from "../../../shared/types/filters";
import CreatableSelect from "react-select/creatable";
import {APIResponse} from "../../../shared/types/types";
import AddPaymentPlan from "../../payment-plan/add-payment-plan/add-payment-plan";

function AddProperty() {

    const {axiosRequestHelper} = useContext(AuthContext);

    const [state, setState] = useState<PropertyInfo>({
        id: null,
        developer_ids: [],
        payment_plan_ids: [],
        amenity_ids: [],
        amenities: [],
        property_images: [],
        name: "",
        type: "",
        description: "",
        bed: "",
        bath: "",
        min_bed: null,
        max_bed: null,
        min_bath: null,
        max_bath: null,
        area: null,
        street_address: "",
        county: "",
        state: "",
        country: "",
        zipcode: "",
        price: null,
        status: PropertyStatus.Open,
        latitude: null,
        longitude: null,
    });
    const [filters, setFilters] = useState<Filters>({
        name: "",
        page: 1,
        page_size: 100
    });
    const [paymentPlanFilters, setPaymentPlanFilters] = useState<PaymentPlanFilters>({
        name: "",
        page: 1,
        page_size: 100,
        ids: []
    })
    const [developers, setDevelopers] = useState<Developer[]>([]);
    const [paymentPlans, setPaymentPlans] = useState<PaymentPlan[]>([]);
    const [amenities, setAmenities] = useState<Amenity[]>([]);
    // const [addressOptions, setAddressOptions] = useState<{value: string; label: string}[]>([]);
    // const [address, setAddress] = useState<string>("");
    const [addressLookupStatus, setAddressLookupStatus] = useState<boolean | null>(null);
    const [status, setStatus] = useState<APIResponse>({
        code: 0,
        msg: "",
    });
    const [imageFile, setImageFile] = useState<File[]>([]);
    const [imageJobStatus, setImageJobStatus] = useState<FileJob[]>([]);
    const [imageUploadStatus, setImageUploadStatus] = useState<boolean>(true);

    const [showPaymentPlanModal, setShowPaymentPlanModal] = useState(false);

    const statusOptions = [
        {value: PropertyStatus.Open, label: "Open"},
        {value: PropertyStatus.Sold, label: "Sold"},
        {value: PropertyStatus.ComingSoon, label: "ComingSoon"},
    ];

    useEffect(() => {
        getDeveloperList();
        getPaymentPlanList();
        getAmenityList();
    }, []);

    const getDeveloperList = () => {
        axiosRequestHelper.get<DeveloperGetSearchResponse>(`${DEVELOPER_API_PATH}/search`, {
            params: {
                ...filters
            }
        }).then((resp) => {
            var data: Developer[] = resp.data.data.map((developer: DeveloperInfo) => ({
                id: developer.id,
                name: developer.name,
            }));
            setDevelopers(data);
        }).catch((error) => {
            console.log("Error: ", error);
        })
    };

    const getPaymentPlanList = () => {
        axiosRequestHelper.get<PaymentPlanSearchResponse>(`${PAYMENT_PLAN_API_PATH}/search`, {
            params: {
                ...paymentPlanFilters
            }
        }).then((resp) => {
            var data: PaymentPlan[] = resp.data.data.map((paymentPlan: PaymentPlanInfo) => ({
                id: paymentPlan.id,
                name: paymentPlan.plan_format.map(plan => plan?.percentage?.toString()).join("/"),
            }));
            setPaymentPlans(data);
        }).catch((error) => {
            console.log("Error: ", error);
        })
    };

    const getAmenityList = () => {
        axiosRequestHelper.get<AmenityGetResponse>(`${AMENITY_API_PATH}/search`, {
            params: {
                ...filters
            }
        }).then((resp) => {
            var data: Amenity[] = resp.data.data.map((amenity: AmenityInfo) => ({
                id: amenity.id,
                name: amenity.name,
            }));
            setAmenities(data);
        }).catch((error) => {
            console.log("Error: ", error);
        })
    };

    const getCoordinates = () => {
        const address = `${state.street_address}, ${state.county}, ${state.state}, ${state.country}`;
        const url = `https://nominatim.openstreetmap.org/search`;
        // ?format=json&q=${encodeURIComponent(address)}`;
        axios.get(url, {
            params: {
                q: address,
                format: 'json'
            },
            headers: {
                'Accept-Language': 'en'
            }
        }).then((resp) => {
            return resp.data;
        }).then(data => {
            console.log("Coordinates: ", data);
            setState({
                ...state,
                latitude: parseFloat(data[0].lat),
                longitude: parseFloat(data[0].lon),
            })
            setAddressLookupStatus(true);

        }).catch((error) => {
            console.log("Error: ", error);
            setAddressLookupStatus(false);
        })
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value, type} = event.target;
        if (type==="file" && event.target.files) {
            const images = Array.from(event.target.files);
            setImageFile([
                ...imageFile,
                ...images]
            );
        } else {
            setState({
                ...state,
                [name]: (name === "price" || name === "area" || name === "latitude" || name === "longitude" || name.includes("bed") || name.includes("bath")) ? parseFloat(value) : value,
            });
        }
    };

    const handleSelectChange = (selectedOptions: any, name: keyof Property) => {
        const value = Array.isArray(selectedOptions) ? selectedOptions.map((option: any) => option.value) : selectedOptions?.value;
        setState({
            ...state,
            [name]: value,
        })
    };

    const postDeveloper = (developerName: string) => {
        axiosRequestHelper.post<APIResponse>(`${DEVELOPER_API_PATH}`, {
        name: developerName,
            phone_number: "",
            description: "",
        }).then((resp) => {
            getDeveloperList()
        }).catch((error) => {
            console.log("Error: ", error);
        })
    };

    const postAmenity = (amenityName: string) => {
        axiosRequestHelper.post<APIResponse>(`${AMENITY_API_PATH}`, {
            name: amenityName,
            phone_number: "",
            description: "",
        }).then((resp) => {
            getAmenityList()
        }).catch((error) => {
            console.log("Error: ", error);
        })
    };

    const postPaymentPlan = (paymentPlanName: string) => {
        setShowPaymentPlanModal(true);
    };

    const closePaymentPlanModal = () => {
        setShowPaymentPlanModal(false);
        getPaymentPlanList();
    }

    const handleDescriptionChange = (content: string) => {
      setState({
          ...state,
          description: content,
      })
    };

    // const handleAddressChange = (address: string) => {
    //     const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`;
    //     axios.get(url).then((resp) => {
    //         return resp.data;
    //     }).then(data => {
    //         const addresses = data.map(d => ({value: d.display_name, label: d.display_name}));
    //         setAddressOptions(addresses);
    //     }).catch((error) => {
    //         console.log("Error: ", error);
    //     })
    // }

    const uploadPropertyImages = (propertyId: number) => {
        var formData = new FormData();
        imageFile.map(image => formData.append("images", image))
        axiosRequestHelper.post(`${PROPERTY_API_PATH}/${propertyId}/upload-image`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }).then((resp) => {
            return resp.data;
        }).then((data: ImageUploadResponse) => {
            console.log("Response: ", data);
            // setImageJobStatus([
            //     ...imageJobStatus.filter(image => !imageNames.includes(image.file_name)),
            //     ...data.data
            // ])
            setImageJobStatus(data.data)
            setStatus({
                code: data.code,
                msg: data.msg,
            })
        }).catch((error) => {
            console.log("Error: ", error);
            setStatus({
                ...error.response.data,
            })
        })
    }

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        console.log("Submit");
        const address = `${state.street_address}, ${state.county}, ${state.state}, ${state.country}`;
        const property: Property = {
            developer_ids: state.developer_ids,
            payment_plan_ids: state.payment_plan_ids,
            amenity_ids: state.amenity_ids,
            name: state.name,
            type: state.type,
            description: state.description,
            bed: state.max_bed?.toString() ?? "",
            bath: state.max_bath?.toString() ?? "",
            min_bed: state.min_bed,
            max_bed: state.max_bed,
            min_bath: state.min_bath,
            max_bath: state.max_bath,
            area: state.area,
            street_address: state.street_address,
            county: state.county,
            state: state.state,
            country: state.country,
            zipcode: state.zipcode,
            price: state.price,
            status: state.status,
            latitude: state.latitude,
            longitude: state.longitude,
        }
        console.log("Property: ", property);
        setImageJobStatus([]);
        axiosRequestHelper.post(`${PROPERTY_API_PATH}`, property).then(resp => {
            return resp.data;
        }).then((data: PropertyCreateResponse) => {
            setState({
                ...state,
                id: data.id,
            })
            setStatus({
                code: data.code,
                msg: data.msg,
            })
            uploadPropertyImages(data.id);

        }).catch((error) => {
            console.log("Error: ", error);
            setStatus({
                ...error.response.data,
            })
        })
        console.log(address);
        return event;
    };

    return (
        <div className="d-flex justify-content-center" style={{paddingTop: "100px", marginTop: "20px"}}>
            <div className="card" style={{width: '80%'}}>
                <div className="card-body">
                    {
                        status.code !== 0 ? (status.code === 200 ? (<div className="alert alert-success">{status.msg}</div>) : (<div className="alert alert-danger">{status.msg}</div>)) : null
                    }
                    <form method="POST" onSubmit={handleSubmit} className="needs-validation">
                        <h2 className="card-title text-center">Add Property</h2>
                        <div className="row">
                            <h4>Building Details</h4>
                            <div className="col-6">
                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="name">Building Name</label>
                                    <input type="text" className="form-control" placeholder="Enter Building Name"
                                           id="name" name="name" onChange={handleChange}
                                           value={state.name} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="price">Price</label>
                                    <input type="number" className="form-control" placeholder="Enter Price"
                                           id="price" name="price" onChange={handleChange}
                                           value={state.price ?? ""} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="min_bed">Minimum Beds</label>
                                    <input type="number" className="form-control" placeholder="Enter Minimum Bedrooms"
                                           id="min_bed" name="min_bed" onChange={handleChange}
                                           value={state.min_bed ?? ""} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="max_bed">Maximum Beds</label>
                                    <input type="number" className="form-control" placeholder="Enter Maximum Bedrooms"
                                           id="max_bed" name="max_bed" onChange={handleChange}
                                           value={state.max_bed ?? ""} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label>Developer Name</label>
                                    <CreatableSelect
                                        options={developers.map(option => ({value: option.id, label: option.name}))}
                                        onChange={(selectedOptions) => handleSelectChange(selectedOptions, "developer_ids")}
                                        onCreateOption={postDeveloper}
                                        placeholder="Select Developer"
                                        value={developers.filter(developer => state.developer_ids.includes(developer.id))
                                            .map(developer => ({value: developer.id, label: developer.name}))}
                                        isMulti={true}
                                        isClearable={true}
                                        isSearchable={true} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label>Amenity</label>
                                    <CreatableSelect
                                        options={amenities.map(option => ({value: option.id, label: option.name}))}
                                        onChange={(selectedOptions) => handleSelectChange(selectedOptions, "amenity_ids")}
                                        onCreateOption={postAmenity}
                                        placeholder="Select Amenity"
                                        value={amenities.filter(amenity => state.amenity_ids.includes(amenity.id))
                                            .map(amenity => ({value: amenity.id, label: amenity.name}))}
                                        isMulti={true}
                                        isClearable={true}
                                        isSearchable={true} required/>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="type">Building Type</label>
                                    <input type="text" className="form-control" placeholder="Enter Building Type"
                                           id="type" name="type" onChange={handleChange}
                                           value={state.type} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label>Status</label>
                                    <Select options={statusOptions}
                                            onChange={(selectedOptions) => handleSelectChange(selectedOptions, "status")}
                                            placeholder="Select Status"
                                            value={statusOptions.find(status => status.value === state.status)}
                                            isSearchable={true} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="min_bath">Minimum Bath</label>
                                    <input type="number" className="form-control" placeholder="Enter Minimum Bathrooms"
                                           id="min_bath" name="min_bath" onChange={handleChange}
                                           value={state.min_bath ?? ""} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="max_bath">Maximum Bath</label>
                                    <input type="number" className="form-control" placeholder="Enter Maximum Bathrooms"
                                           id="max_bath" name="max_bath" onChange={handleChange}
                                           value={state.max_bath ?? ""} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="area">Area</label>
                                    <input type="number" className="form-control" placeholder="Enter Area in SqFt"
                                           id="area" name="area" onChange={handleChange}
                                           value={state.area ?? ""} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label>Payment Plan</label>
                                    <CreatableSelect
                                        options={paymentPlans.map(option => ({value: option.id, label: option.name}))}
                                        onChange={(selectedOptions) => handleSelectChange(selectedOptions, "payment_plan_ids")}
                                        onCreateOption={postPaymentPlan}
                                        placeholder="Select Payment Plan"
                                        value={paymentPlans.filter(paymentPlan => state.payment_plan_ids.includes(paymentPlan.id ?? 0))
                                            .map(paymentPlan => ({value: paymentPlan.id, label: paymentPlan.name}))}
                                        isMulti={true}
                                        isClearable={true}
                                        isSearchable={true} required/>
                                    <Modal show={showPaymentPlanModal} onHide={() => setShowPaymentPlanModal(false)}
                                           centered>
                                        <Modal.Header closeButton>
                                            <Modal.Title>Create Payment Plan</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <AddPaymentPlan paymentPlanName={"Payment Plan"}
                                                            closePaymentPlanModal={closePaymentPlanModal}></AddPaymentPlan>
                                        </Modal.Body>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <div className="row">

                            <div className="d-flex align-items-center">
                                <h4 className="mb-0 me-2">Address</h4>
                                {addressLookupStatus === null ? null : (
                                    <FontAwesomeIcon
                                        icon={addressLookupStatus ? faCheck as IconProp : faTimes as IconProp}
                                        className={addressLookupStatus ? "text-success" : "text-danger"}
                                    />
                                )}
                                <div className="ms-auto">
                                    <Button className="btn btn-outline-deepNavyBlue"
                                            onClick={getCoordinates}>
                                        <FontAwesomeIcon icon={faMagnifyingGlass as IconProp}/> Look Up
                                    </Button>
                                </div>
                            </div>

                            {/*<div className="form-group pb-3 pt-2">*/}
                            {/*    <Select options={addressOptions}*/}
                            {/*            onInputChange={(address) => handleAddressChange(address)}*/}
                            {/*            placeholder="Type Address"*/}
                            {/*            value={addressOptions.find(addressOption => addressOption.value === address)}*/}
                            {/*            isSearchable={true}/>*/}
                            {/*</div>*/}
                            <div className="col-6">
                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="street_address">Street Address</label>
                                    <input type="text" className="form-control" placeholder="Enter Street Address"
                                           id="street_address" name="street_address" onChange={handleChange}
                                           value={state.street_address} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="state">State</label>
                                    <input type="text" className="form-control" placeholder="Enter State Name"
                                           id="state" name="state" onChange={handleChange}
                                           value={state.state} required/>
                                </div>

                                {
                                    addressLookupStatus === null ? null : (
                                        !addressLookupStatus &&
                                        <div className="form-group pb-3 pt-2">
                                            <label htmlFor="latitude">Latitude</label>
                                            <input type="number" className="form-control" placeholder="Enter Latitude"
                                                   id="latitude" name="latitude" onChange={handleChange}
                                                   value={state.latitude ?? 0} required/>
                                        </div>
                                    )
                                }
                            </div>
                            <div className="col-6">
                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="county">Area/County</label>
                                    <input type="text" className="form-control" placeholder="Enter Area Name"
                                           id="county" name="county" onChange={handleChange}
                                           value={state.county} required/>
                                </div>

                                <div className="form-group pb-3 pt-2">
                                    <label htmlFor="country">Country</label>
                                    <input type="text" className="form-control" placeholder="Enter Country Name"
                                           id="country" name="country" onChange={handleChange}
                                           value={state.country} required/>
                                </div>

                                {
                                    addressLookupStatus === null ? null : (
                                        !addressLookupStatus &&
                                        <div className="form-group pb-3 pt-2">
                                            <label htmlFor="longitude">Longitude</label>
                                            <input type="number" className="form-control" placeholder="Enter longitude"
                                                   id="longitude" name="longitude" onChange={handleChange}
                                                   value={state.longitude ?? 0} required/>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        <hr/>
                        <div className="row">
                            <h4>Additional Information</h4>
                            <div className="form-group pb-3 pt-2">
                                <label>Description</label>
                                <ReactQuill theme="snow"
                                            className="description"
                                            placeholder="Enter Description"
                                            value={state.description}
                                            onChange={handleDescriptionChange}/>
                            </div>
                        </div>
                        <hr/>
                        <div className="row">
                            <h4>Upload Images</h4>
                            {/*<div className="image-preview mt-3">*/}
                            {/*    {state.property_images.map((image, index) => (*/}
                            {/*        <div key={index} className="preview-thumbnail">*/}
                            {/*            <img src={URL.createObjectURL(image)}*/}
                            {/*             alt={`Property image ${index + 1}`}*/}
                            {/*             style={{ width: '100px', height: '1000px', objectFit: 'cover', margin: '5px' }}/>*/}
                            {/*        </div>*/}
                            {/*    ))}*/}
                            {/*</div>*/}
                            <div className="form-group pb-3 pt-2">
                                <label htmlFor="property_images">Images</label>
                                <input type="file"
                                       className="form-control"
                                       placeholder="Upload Images"
                                       id="imageFile"
                                       name="imageFile"
                                       onChange={handleChange}
                                       accept="image/*"
                                       multiple={true} required/>
                            </div>
                        </div>
                        {/*<div className="image-status">*/}
                        {/*    {imageJobStatus.map((job, index) => (*/}
                        {/*        <div className="progress" key={index}>*/}
                        {/*            <ProgressBar variant={job.err.length === 0 ? "success" : "danger"} now={100}/>*/}
                        {/*            {*/}
                        {/*                job.err.length === 0 && (*/}
                        {/*                    <Button*/}
                        {/*                        onClick={() => uploadPropertyImages(state.id ?? 0, [job.file_name])}><FontAwesomeIcon*/}
                        {/*                        icon={faUpload as IconProp}/></Button>*/}
                        {/*                )*/}
                        {/*            }*/}

                        {/*        </div>*/}
                        {/*    ))}*/}
                        {/*</div>*/}
                        {/*<div className="image-status">*/}
                        {/*    {!imageUploadStatus && imageFile.map((image, index) => (*/}
                        {/*        <div className="image-status-item" key={index}>*/}
                        {/*            <ProgressBar variant={"danger"} now={100}/>*/}
                        {/*            <Button*/}
                        {/*                onClick={() => uploadPropertyImages(state.id ?? 0, [image.name])}><FontAwesomeIcon*/}
                        {/*                icon={faUpload as IconProp}/></Button>*/}
                        {/*        </div>*/}
                        {/*    ))}*/}
                        {/*</div>*/}
                        <button className="btn btn-deepNavyBlue float-end" type="submit">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    );

}

export default AddProperty;